import { create } from 'zustand';
import { StateStorage, createJSONStorage, persist } from 'zustand/middleware';

/** No-op storage for SSR, where sessionStorage does not exist. */
const noopStorage: StateStorage = {
    getItem: () => null,
    setItem: () => undefined,
    removeItem: () => undefined
};

interface ShowAllModulesStore {
    showAll: boolean;
    setShowAll: (value: boolean) => void;
    toggle: () => void;
}

/**
 * The escape hatch: "show all modules" reveals everything the club has hidden, per user
 * and per session.
 *
 * ⚠️ sessionStorage on purpose, not localStorage — the setting must not outlive the tab.
 * It is a way back into a module someone hid by accident, not a second, permanent
 * configuration. It never touches the club setting.
 */
export const useShowAllModules = create<ShowAllModulesStore>()(
    persist(
        (set, get) => ({
            showAll: false,
            setShowAll: (value: boolean) => set({ showAll: value }),
            toggle: () => set({ showAll: !get().showAll })
        }),
        {
            name: 'sportision:show-all-modules',
            storage: createJSONStorage(() => (typeof window === 'undefined' ? noopStorage : window.sessionStorage))
        }
    )
);

export default useShowAllModules;
